import { usePwaInstall } from "@/hooks/use-pwa-install";
import { usePwaUpdate } from "@/hooks/usePwaUpdate";
import { PwaInstallBanner } from "./PwaInstallBanner";
import { PwaUpdateBanner } from "./PwaUpdateBanner";

export function PwaClient() {
  const { dismissPromotion, installLabel, promptInstall, showInstallBanner } = usePwaInstall();
  const { updateReady, reloadApp, dismissUpdate } = usePwaUpdate();

  return (
    <>
      {updateReady ? (
        <PwaUpdateBanner onDismiss={dismissUpdate} onReload={reloadApp} />
      ) : null}
      {showInstallBanner ? (
        <PwaInstallBanner onDismiss={dismissPromotion} onInstall={promptInstall} installLabel={installLabel} />
      ) : null}
    </>
  );
}
